module.exports = __webpack_public_path__ + "static/media/63 - logo ppia deakin.804bc718.png";